import { render, staticRenderFns } from "./table-item.vue?vue&type=template&id=fd54453e&scoped=true"
import script from "./table-item.vue?vue&type=script&lang=js"
export * from "./table-item.vue?vue&type=script&lang=js"
import style0 from "./table-item.vue?vue&type=style&index=0&id=fd54453e&prod&lang=less&scoped=true"
import style1 from "./table-item.vue?vue&type=style&index=1&id=fd54453e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd54453e",
  null
  
)

export default component.exports